import React, { Component } from 'react';

import * as API from './api.js';
import './style.css';
import { Modal } from "react-bootstrap";
import success from './assets/check_circle_24px.png';
import fail from './assets/error.png';
import closeButton from './close-button.png';
import waiting from './res/waiting.png';

import { Link, StaticRouter, Redirect } from 'react-router-dom';
import AppConstants from './AppConstants.js';
import { ActivityPopup } from './ReusableComponents/ActivityPopup.js';
import { Popup } from './ReusableComponents/reusableFunctions.js';
import ButtonWithIcon from './ReusableComponents/ButtonWithIcon.js';
import LoaderComponent from './ReusableComponents/LoaderComponent.js';
import { set } from 'lodash';
import TableView from './ReusableComponents/TableView/TableView.js';
export default class AdminAddChangeSubscription extends Component {

    state = {
        user: {},
        type: "",
        plans: [],
        plan_id: 0,
        user_info: {},
        plan: '',
        redirect: false,
        config: {},
        planItems: [],
        popupText: "",
        updateSubPopup: false,
        selected_plan: {},
        alertPopup: false,
        tableLoading: true,
        loading: true,
        tableState: {
            pageNumber: 1,
            pageSize: 15,
        },
        count: 0,
        activityPopup: false,
        zoho_plan_code:""
    }

    getSubscriptionPlan = () => {
        API.getSubscriptionPlan().then((data) => {
            let planData = []
            let userSubServices = this.state.user_info.subs.map((sub) => { return sub.plan_name })
            console.log(data)
            planData = data.plans.filter((plan) => userSubServices.indexOf(plan.plan_name) == -1 && plan.status == "Active" && (plan.service == AppConstants.SERVICES.AEROGCS || plan.service == AppConstants.SERVICES.DRONE_CONTROL_CENTER))
            this.setState((state) => ({
                ...state,
                plans: planData,
                plan_id: planData[0].id,
                zoho_plan_code : planData[0].zoho_plan_code
            }), () => {
                this.getSubscriptionPlanItems()
            })
        })
    }

    // Get subscription plan items list under the plan
    getSubscriptionPlanItems = () => {
        this.setState({ tableLoading: true })
        let sel_plan = this.state.plans.find(data => data.id == this.state.plan_id)
        let existing_plan = this.state.user_info.subs.find((data) => data.service == sel_plan.service)

        this.setState((state) => ({
            ...state,
            selected_plan: sel_plan,
            existing_plan: existing_plan
        }))

        API.getSubscriptionPlanItems(this.state.plan_id, undefined, this.state.tableState).then((data) => {
            this.setState((state) => ({
                ...state,
                planItems: data.items,
                loading: false,
                count: data?.items?.[0]?.total_count || 0,
                tableLoading: false,
            }))
        })
    }

    onChangeListener = (e) => {
        let t = e.target;
        this.setState((state) => ({
            ...state,
            [t.name]: t.value
        }), () => {
            this.getSubscriptionPlanItems()
        })
    }

    componentWillMount() {
        document.title = "Admin Assign Subscription";
        if (!this.props.location.state) {
            API.getUserType().then(([registered, type, user, user_info]) => {
                // if promise is resolved, update state and redirect user
                this.setState({
                    registered,
                    type,
                    user,
                    user_info
                })
            }, (e) => {
                // if promise is rejected, log the error, and display message to user
                this.setState({
                    user: {},
                    type: 'unknown'
                })
                window.location.replace("/login");
            })
        } else {
            if (this.props.location.state.config) {
                this.setState((state) => ({
                    ...state,
                    user: this.props.location.state.config.user,
                    type: this.props.location.state.config.type,
                    user_info: this.props.location.state.user_info
                }), () => {
                    this.getSubscriptionPlan()
                })
            } else if (this.props.location.state.user) {
                this.setState((state) => ({
                    ...state,
                    user: this.props.location.state.user,
                    type: this.props.location.state.type,
                    user_info: this.props.location.state.user_info
                }), () => {
                    this.getSubscriptionPlan()
                })
            }
        }
    }

    addOrUpgradePlan = () => {
        this.setState({
            activityPopup: {
                icon: "WAIT",
                message: this.state.existing_plan === undefined ? "Adding Subscription Plan, Please Wait..." : "Updating Subscription Plan, please wait...",
            }
        })
        let date = new Date()
        var expiry_date = this.state.selected_plan.plan_type == 'Yearly' ? new Date(date.setFullYear(date.getFullYear() + this.state.planLengthDays))
            : new Date(date.setMonth(date.getMonth() + this.state.planLengthDays));
        expiry_date = expiry_date.toISOString()
        let type = "Manual"
        if (this.state.existing_plan === undefined) {
            API.saveUserSubscriptionPlan(this.state.plan_id, expiry_date, this.state.user_info.userid, type).then(async (data) => {
                if (data.status == 200) {
                    this.setState({
                        activityPopup: {
                            icon: "COMPLETE",
                            message: `User is subscribed to plan '${this.state.selected_plan.plan_name}' Successfully`,
                        }
                    }, () => {
                        this.props.history.push('/admin/userdetails', {
                            user: this.state.user,
                            user_info: this.state.user_info
                        });
                    })
                } else {
                    let res = await data.json()
                    this.setState({
                        activityPopup: {
                            icon: "ERROR",
                            message: res.message,
                        }
                    })
                }
            }, (e) => {
                console.log(e);
                this.setState({
                    activityPopup: {
                        icon: "ERROR",
                        message: "Something went wrong... ",
                    }
                })
            })
        } else {
            API.updateUserSubscriptionPlan(this.state.existing_plan.id, this.state.plan_id, expiry_date, this.state.user_info.userid, this.props?.location?.state?.manual ? 'Manual' : 'Auto',this.state.selected_plan.zoho_plan_code,this.props.location.state.manual).then((data) => {
                if (data.message == "User subscription plan updated." || data.message == 'User subscription plan updated on Zoho, waiting for payment to complete.') {
                    this.setState({
                        activityPopup: {
                            icon: "COMPLETE",
                            message: 'Plan Updated Successfully',
                        }
                    }, () => {
                        setTimeout(() => {
                            this.props.history.push('/admin/userdetails', {
                                user: this.state.user,
                                user_info: this.state.user_info
                            });
                        }, 2000)
                    })
                } else {
                    this.setState({
                        activityPopup: {
                            icon: "ERROR",
                            message: data.message || data.errorMessage,
                        }
                    })
                }
            }, (e) => {
                console.log(e);
                this.setState({
                    activityPopup: {
                        icon: "ERROR",
                        message: "Something went wrong... ",
                    }
                })
            })
        }
    }

    closeActivityPopup = () => {
        this.setState({
            activityPopup: false,
            updateSubPopup: false,
        })
    }

    render() {
        let { user, user_info, } = this.state

        return <div className="wrapper">
            <div className="right-content-new" >
                <ActivityPopup
                    item={this.state.activityPopup?.item}
                    open={this.state.activityPopup}
                    icon={this.state.activityPopup?.icon}
                    action={this.state.activityPopup?.action}
                    msg={this.state.activityPopup?.message}
                    close={() => {
                        this.closeActivityPopup()
                    }}
                    onClickOk={() => {
                        if (this.state.updateSubPopup) {
                            this.addOrUpgradePlan()
                        }
                    }}
                />

                <div className="top-bar-new"><div className="top-bar-text-new">ADD SUBSCRIPTION</div></div>
                {this.state.loading ? <LoaderComponent />
                    : <div className="main-content-new">
                        <div className="page" style={{ height: 'calc(100% - 50px)', minWidth: "60vw", width: "60vw", marginTop: '10px' }}>
                            <div style={{ display: "flex", alignItems: 'center', gap: '30px', width: "100%" }}>
                                <div className="customer-details-primary-row-left">
                                    <div className="customer-details-primary-row-left-title">User Name:</div>
                                    <div className="customer-details-primary-row-left-value">{`${user_info.first_name} ${user_info.last_name}`}</div>
                                </div>
                                <div className="customer-details-primary-row-left">
                                    <div className="customer-details-primary-row-left-title">User Email:</div>
                                    <div className="customer-details-primary-row-left-value">{`${user_info.username}`}</div>
                                </div>
                            </div>

                            <div className="add-user-form-row" style={{ marginTop: "20px" }}>
                                <div className="add-user-form-row-left">
                                    <div className="add-user-form-label"> Plan</div>
                                    <div className="add-user-form-text-wrapper" style={{ width: "25vw" }}>
                                        <select
                                            name="plan_id"
                                            onChange={this.onChangeListener}
                                            value={this.state.plan_id}
                                            className="sub-add-user-form-text"
                                        >
                                            {this.state.plans.map((plan) => {
                                                return <option value={plan.id}>{`${plan.plan_name} (${plan.plan_type})`}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="add-user-form-row-right" style={{ marginLeft: "3%" }}>
                                    <div className="add-user-form-label">
                                        Subscription Period
                                    </div>
                                    <div className="add-user-form-text-wrapper" style={{
                                        display: "flex",
                                        width: "28vw",
                                        alignItems: "center",
                                    }}>
                                        <input className="sub-add-user-form-text" type="number" value={this.state.planLengthDays} onChange={(e) => {
                                            let v = e.target.value
                                            this.setState((prevState) => ({
                                                ...prevState,
                                                planLengthDays: parseInt(v)
                                            }))
                                        }} min="0"></input>
                                        <div style={{ position: "relative", right: "70px", }}>{this.state.selected_plan.plan_type == 'Yearly' ? 'Year(s)' : 'Month(s)'}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="add-user-form-row" style={{ display: "block", marginTop: "20px" }}>
                                <div style={{
                                    fontWeight: "bold",
                                    fontSize: "24px",
                                    marginBottom: "20px"
                                }}>Plan Details</div>
                            </div>
                            <div style={{ height: "calc(100% - 300px)", marginTop: '10px' }} >
                                <TableView
                                    isLoading={this.state.tableLoading}
                                    count={this.state.count}
                                    columns={[
                                        { Header: "Name", accessor: "item_name", width: '60%' },
                                        { Header: "Limit", accessor: "limits", width: '40%' },
                                    ]}
                                    data={this.state.planItems || []}
                                    user={this.state.user}
                                    onClickRow={(plan) => {
                                        // this.props.history.push('/admin/new_subscription', { user, plan })
                                    }}
                                    onStateChange={(state) => { this.setState({ tableState: state }, () => { this.getSubscriptionPlanItems() }) }}
                                />
                            </div>

                            <div className="add-user-form-action-row" style={{ float: "right" }}>
                                <ButtonWithIcon
                                    text={"Cancel"}
                                    width="94px"
                                    onClick={() => {
                                        this.props.history.push('/admin/userdetails', {
                                            user: this.state.user,
                                            user_info: this.state.user_info
                                        });
                                    }}
                                />
                                <ButtonWithIcon
                                    text={"Save"}
                                    width="94px"
                                    isBtnActive
                                    isDisabled={this.state.planLengthDays < 1 || !this.state.plan_id}
                                    onClick={() => {
                                        if (!this.state.planLengthDays || this.state.planLengthDays == 0) {
                                            Popup.alert('ERROR', 'Please Enter Subscription Period.')
                                        } else if (this.state.existing_plan === undefined) {
                                            this.addOrUpgradePlan()
                                        } else {
                                            this.setState({
                                                updateSubPopup: true,
                                                activityPopup: {
                                                    icon: "WARNING",
                                                    message: `Your existing plan '${this.state.existing_plan ? this.state.existing_plan.plan_name : ''}' will be replaced by the new plan : '${this.state.selected_plan.plan_name}'. Are you sure you want to update existing plan ?`,
                                                }
                                            })
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>}
            </div>
        </div>
    }
}
